const INSIDER_LOGIN_INIT = 'insider/INSIDER_LOGIN_INIT';
const INSIDER_HIDE_NOTIFICATION = 'insider/INSIDER_HIDE_NOTIFICATION';
const INSIDER_SHOW_NOTIFICATION = 'insider/INSIDER_SHOW_NOTIFICATION';

const initialState = {
    insiderLoginInitiated: false,
    insiderLoginComplete: false,
    showNotification: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INSIDER_LOGIN_INIT:
      return {
        ...state,
        loginInitiated: true
      }
    case INSIDER_SHOW_NOTIFICATION:
      return {
        ...state,
        showNotification: true
      }   
    case INSIDER_HIDE_NOTIFICATION:
      return {
        ...state,
        showNotification: false
      }       
    default:
      return state;
  }
}

export function insiderLoginInitiated() {
    return {
        type: INSIDER_LOGIN_INIT
    }
}

export function showNotification() {
    return {
        type: INSIDER_SHOW_NOTIFICATION
    }
}

export function hideNotification() {
    return {
        type: INSIDER_HIDE_NOTIFICATION
    }
}



// WEBPACK FOOTER //
// ./modules/Insider/reducers/reducer.js